module.exports = __webpack_public_path__ + "static/media/netto-circle-only.d1445eb3.svg";